import React, { useCallback, useReducer } from 'react';
import { withAdditionalValidationReducer } from './withAdditionalValidationReducer';
import {
	IAdditionalValidationError,
	WithAdditionalValidationContext,
	withAdditionalValidationState,
} from './withAdditionalValidationContext';
import { WithAdditionalValidationActions } from './withAdditionalValidationActions';

const WithAdditionalValidationState = ({ children }: JSX.ElementChildrenAttribute) => {
	const [state, dispatch] = useReducer(withAdditionalValidationReducer, withAdditionalValidationState);

	const setMainFormValidationFail = useCallback((failStatus: boolean) => {
		dispatch({
			type: WithAdditionalValidationActions.SET_MAIN_FORM_VALIDATION_FAIL,
			payload: {
				failStatus,
			},
		});
	}, []);

	const addAdditionalValidationError = useCallback((validationError: IAdditionalValidationError) => {
		dispatch({
			type: WithAdditionalValidationActions.ADD_ADDITIONAL_VALIDATION_ERROR,
			payload: {
				validationError,
			},
		});
	}, []);

	const removeAdditionalValidationError = useCallback((errorId: string) => {
		dispatch({
			type: WithAdditionalValidationActions.REMOVE_ADDITIONAL_VALIDATION_ERROR,
			payload: {
				errorId,
			},
		});
	}, []);

	const removeAllAdditionalValidationErrorsInBlock = useCallback((blockId: string) => {
		dispatch({
			type: WithAdditionalValidationActions.REMOVE_ALL_ADDITIONAL_VALIDATION_ERRORS_IN_BLOCK,
			payload: {
				blockId,
			},
		});
	}, []);

	return (
		<WithAdditionalValidationContext.Provider
			value={{
				mainFormValidationFail: state.mainFormValidationFail,
				additionalValidationErrors: state.additionalValidationErrors,
				setMainFormValidationFail,
				addAdditionalValidationError,
				removeAdditionalValidationError,
				removeAllAdditionalValidationErrorsInBlock,
			}}>
			{children}
		</WithAdditionalValidationContext.Provider>
	);
};

export default React.memo(WithAdditionalValidationState);
